import Service from "../../AuthService";
const RateSalaryHistory = {
    getRateSalaryHistory(page) {
        return Service.get("/rate_salary_history?page="+page);
    },
    searchRateSalaryHistory(data){
        return Service.post("/rate_salary_history_search",data);
    }
};
export default RateSalaryHistory;
